import { User } from "lucide-react";

const isPhotoUrl = (url) => {
  if (!url) return false;
  // Treat customer-uploaded assets, our own hosted team photos, MongoDB-backed
  // uploads served via /api/uploads/, and inline data URLs as real photos.
  // Default placeholder Unsplash team URLs are skipped so members without a
  // real headshot continue to show the "Photo to come" placeholder.
  return (
    url.startsWith("data:image/") ||
    url.includes("customer-assets.emergentagent.com") ||
    url.includes("/team-photos/") ||
    url.startsWith("/api/uploads/") ||
    url.includes("/api/uploads/")
  );
};

export const TeamCard = ({ member }) => {
  const showPhoto = isPhotoUrl(member.image_url);
  const testId = member.name.toLowerCase().replace(/\s+/g, "-");

  return (
    <div className="team-card group" data-testid={`team-member-${testId}`}>
      {/* Photo or placeholder */}
      {showPhoto ? (
        <div
          className="aspect-[3/4] overflow-hidden mb-6 bg-neutral-900 border border-neutral-800"
          data-testid={`team-photo-${testId}`}
        >
          <img
            src={member.image_url}
            alt={member.name}
            loading="lazy"
            className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500"
          />
        </div>
      ) : (
        <div
          className="aspect-[3/4] overflow-hidden mb-6 bg-neutral-900 border border-neutral-800 flex items-center justify-center"
          data-testid={`team-photo-placeholder-${testId}`}
        >
          <div className="flex flex-col items-center gap-3 text-neutral-700">
            <User className="w-16 h-16" strokeWidth={1} />
            <span className="text-[10px] uppercase tracking-widest text-neutral-600">
              Photo to come
            </span>
          </div>
        </div>
      )}

      {/* Info */}
      <div>
        <h3 className="font-heading text-2xl font-semibold text-white mb-1">
          {member.name}
        </h3>
        <p className="text-gray-400 text-sm uppercase tracking-widest mb-4">
          {member.role}
        </p>

        {member.bio.split("\n\n").map((para, i) => (
          <p key={i} className="text-gray-300 leading-relaxed mb-4">
            {para}
          </p>
        ))}

        {/* Experience */}
        <div className="border-t border-neutral-800 pt-4">
          {member.experience ? (
            <p className="text-sm text-white">{member.experience}</p>
          ) : member.experience_years > 0 ? (
            <p className="text-sm text-white">
              <span className="font-semibold">{member.experience_years}+</span> years experience
            </p>
          ) : null}
          {Array.isArray(member.specializations) && member.specializations.length > 0 && (
            <div className="flex flex-wrap gap-2 mt-3">
              {member.specializations.map((spec) => (
                <span
                  key={spec}
                  className="text-xs uppercase tracking-wider px-3 py-1 bg-neutral-800 text-gray-300"
                >
                  {spec}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TeamCard;
